function dcCourseTypesController(UserService, CourseTypesModel, FlashService) {
  const vm = this;
  vm.currentUser = UserService.getCurrentUser();

  vm.addCourseType = addCourseType;
  vm.updatePayRatio = updatePayRatio;

  vm.ageRuleOptions = [
    { n: "All ages", v: "all" },
    { n: ">= (at least)", v: "minimum" },
    { n: "<= (at most)", v: "maximum" },
  ];
  vm.ageRuleHelp =
    'Restrict this course type to students of a certain age. Choose ">= (at least)" or "<= (at most)" and enter an age. ' +
    "Students whose age does not match cannot enroll in, be enrolled in, or purchase courses of this type. " +
    'The comparison includes the age itself, so ">= 18" allows students who are exactly 18. Ages are calculated from the student\'s date of birth.';

  init();

  function init() {
    getCourseTypes();
  }

  function getCourseTypes() {
    CourseTypesModel.get().then((response) => {
      vm.courseTypes = response.courseTypes;
    });
  }

  function addCourseType() {
    CourseTypesModel.insert({ name: vm.courseTypeName }).then((response) => {
      vm.courseTypes = vm.courseTypes.concat(response.courseType);
      vm.courseTypeName = null;
      FlashService.setMessage({ type: "success", message: response.message });
    });
  }

  function updatePayRatio(courseType) {
    vm.updating = true;
    CourseTypesModel.update(courseType).then((response) => {
      FlashService.setMessage({ type: "success", message: response.message });
      vm.updating = false;
    });
  }
}
dcCourseTypesController.$inject = [
  "UserService",
  "CourseTypesModel",
  "FlashService",
];

export default dcCourseTypesController;
